<footer class="site-footer" role="contentinfo">
    <div class="site-footer__container">
        <div class="site-footer__top">
            <div class="site-footer__brand-block">
                <a class="site-footer__brand" aria-label="Rêve Home" routerLink="/"
                    (click)="onNavigationLinkClick('/')">
                    <span class="site-footer__brand-text">Rêve</span>
                </a>
                <div class="site-footer__brand-copy">
                    Engineering continuous cost reduction and structural business transformation for enterprise AI
                    architectures.
                </div>
            </div>

            <nav class="site-footer__nav" aria-label="Footer Navigation">
                <div class="site-footer__heading">Architecture</div>
                <ul class="site-footer__list">
                    <li><a routerLink="/services" (click)="onNavigationLinkClick('/services')">Services Hub</a></li>
                    <li><a routerLink="/plans" (click)="onNavigationLinkClick('/plans')">Plans</a></li>
                    <li><a routerLink="/dynamics-365" (click)="onNavigationLinkClick('/dynamics-365')">Dynamics 365</a>
                    </li>
                    <li><a routerLink="/case-study" (click)="onNavigationLinkClick('/case-study')">Case Studies</a></li>
                    <li><a routerLink="/blog" (click)="onNavigationLinkClick('/blog')">Insights & Blog</a></li>
                    <li><a routerLink="/careers" (click)="onNavigationLinkClick('/careers')">Careers</a></li>
                    <li><a routerLink="/faq" (click)="onNavigationLinkClick('/faq')">FAQ & Knowledge</a></li>
                </ul>
            </nav>

            <div class="site-footer__contact">
                <div class="site-footer__heading">Contact</div>
                <div class="site-footer__email-wrap">
                    <a class="site-footer__email" href="mailto:contact@reve.cloud">contact&#64;reve.cloud</a>
                </div>
                <div class="site-footer__socials" aria-label="Social Media Links">
                    <a class="site-footer__social-link" [href]="linkedinUrl" target="_blank" rel="noopener noreferrer"
                        aria-label="Visit Reve Cloud on LinkedIn">
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path
                                d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                        </svg>
                    </a>
                    <a class="site-footer__social-link" [href]="instagramUrl" target="_blank" rel="noopener noreferrer"
                        aria-label="Visit Reve Cloud on Instagram">
                        <svg class="site-footer__social-icon--stroke" viewBox="0 0 24 24" aria-hidden="true">
                            <rect x="3" y="3" width="18" height="18" rx="5" ry="5"></rect>
                            <circle cx="12" cy="12" r="4"></circle>
                            <circle cx="17.5" cy="6.5" r="1"></circle>
                        </svg>
                    </a>
                </div>
            </div>
        </div>

        <div class="site-footer__addresses">
            <article class="site-footer__address-card">
                <div class="site-footer__region">India HQ</div>
                <div class="site-footer__company">Reve Cloud Tech Pvt Ltd</div>
                <div class="site-footer__address">
                    Embassy TechVillage, Block L,<br />
                    Devarabisanahalli, Outer Ring Rd,<br />
                    Bellandur, Bengaluru,<br />
                    Karnataka 560103
                </div>
            </article>

            <article class="site-footer__address-card">
                <div class="site-footer__region">EMEA Hub</div>
                <div class="site-footer__company">Reve Cloud Ltd.</div>
                <div class="site-footer__address">
                    Suite RA01 195-197<br />
                    Wood Street<br />
                    London E17 3NU
                </div>
            </article>

            <article class="site-footer__address-card">
                <div class="site-footer__region">APAC Hub</div>
                <div class="site-footer__company">Reve Cloud Sdn Bhd</div>
                <div class="site-footer__address">
                    Level 27 Penthouse, Centrepoint North<br />
                    Midvalley City, Lingkaran Syed Putra<br />
                    Kuala Lumpur 59200
                </div>
            </article>

            <article class="site-footer__address-card">
                <div class="site-footer__region">SEA Hub</div>
                <div class="site-footer__company">Reve Cloud Pte. Ltd.</div>
                <div class="site-footer__address">
                    68 Circular Road, #02-01<br />
                    Singapore 049422
                </div>
            </article>
        </div>

        <div class="site-footer__bottom">
            <div class="site-footer__copyright">&copy; 2026 Rêve Cloud Inc. All rights reserved.</div>
            <div class="site-footer__legal-links">
                <a routerLink="/privacy" (click)="onNavigationLinkClick('/privacy')">Privacy Directive</a>
                <a routerLink="/terms" (click)="onNavigationLinkClick('/terms')">Terms of Service</a>
            </div>
        </div>
    </div>
</footer>